exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.confirm-btn[data-v-05e9a24b]{width:100%\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/pfpay-system-manager-merchant/src/components/orders/card-dialog.vue"],"names":[],"mappings":";AACA,8BAA8B,UAAU;CACvC","file":"card-dialog.vue","sourcesContent":["\n.confirm-btn[data-v-05e9a24b]{width:100%\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05e9a24b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/orders/card-dialog.vue
// module id = mVPG
// module chunks = 1